import React from 'react';
import { useLocation } from 'react-router-dom';

// Lightweight replacement for react-router-last-location (v6-compatible)
const LastLocationContext = React.createContext(null);

export function LastLocationProvider({ children }) {
  const location = useLocation();
  const previousRef = React.useRef(null);

  // On every location change, keep the previous location
  React.useEffect(() => {
    previousRef.current = location;
  }, [location]);

  // Expose the previous location (not the current one)
  const value = previousRef.current;

  return (
    <LastLocationContext.Provider value={value}>
      {children}
    </LastLocationContext.Provider>
  );
}

export function useLastLocation() {
  return React.useContext(LastLocationContext);
}
